import { render, staticRenderFns } from "./AuditTrailPanel.vue?vue&type=template&id=35ec5b34&scoped=true"
import script from "./AuditTrailPanel.vue?vue&type=script&lang=js"
export * from "./AuditTrailPanel.vue?vue&type=script&lang=js"
import style0 from "./AuditTrailPanel.vue?vue&type=style&index=0&id=35ec5b34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ec5b34",
  null
  
)

export default component.exports